module.exports = __webpack_public_path__ + "img/5-min.884d95e.png";